import { useCallback } from 'react';
import { useCurrentLanguage } from 'tradera-lang/translate';
import { formatPrice } from 'tradera-utils/format';
import { useSelector } from 'react-redux';
import { selectPreferredCurrency } from 'tradera-state/multi-currency/selectors';

const getOptions = (preferredCurrency, overrides = {}) => ({
    currency: preferredCurrency.code,
    minimumFractionDigits: preferredCurrency.decimals,
    maximumFractionDigits: preferredCurrency.decimals,
    ...overrides
});

export const useLocalizedPriceFormatter = () => {
    const { language } = useCurrentLanguage();
    const preferredCurrency = useSelector(selectPreferredCurrency);
    return useCallback(
        price =>
            formatPrice(
                preferredCurrency.rate * price,
                language,
                getOptions(preferredCurrency)
            ),
        [language, preferredCurrency]
    );
};

export const useLocalizedPriceFormatterNoConversion = () => {
    const { language } = useCurrentLanguage();
    const preferredCurrency = useSelector(selectPreferredCurrency);
    return useCallback(
        price => formatPrice(price, language, getOptions(preferredCurrency)),
        [language, preferredCurrency]
    );
};

export const useLocalizedPriceFormatterNoSymbol = () => {
    const { language } = useCurrentLanguage();
    const preferredCurrency = useSelector(selectPreferredCurrency);
    return useCallback(
        price =>
            formatPrice(
                preferredCurrency.rate * price,
                language,
                getOptions(preferredCurrency, {
                    style: 'decimal'
                })
            ),
        [language, preferredCurrency]
    );
};
